import React, { useState } from 'react'
import './Certificat.css'
import certficatIcon from '../../assets/certificat.png'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';
function Certificat({name, university, organization, date, Id,url }) {
    const [handleClick, setHandleClick] = useState(false)
    return (
        <div className="certificat">
            <div className="certficat__header">
                <img src={certficatIcon} alt=""/>
                <div className="certficat__headerInfo">
                    <h3>{name}</h3>
                    <h4>{university}</h4>
                </div>
            </div>
            <div className={handleClick ? 'certficat__info certficat__info__active' : 'certficat__info'}>
                <p>Name : <span>{name}</span></p>
                <p>Organization : <span>{organization}</span></p>
                <p>Date obtained : <span>{date}</span></p>
                <p>Id : <span>{Id}</span></p>
                <div className="certficat__info__tag">
                <a href={url} target="_blank">{url}</a>
                </div>
            </div>
            <div className={handleClick ? 'showbar showbar__clicked' : 'showbar'}>
                <IconButton onClick={() => setHandleClick(!handleClick)}>
                <KeyboardArrowDownIcon className="keyboardIcon" fontSize="large"/>
                </IconButton>
            </div>
        </div>
    )
}

export default Certificat
